module.exports = __webpack_public_path__ + "bbfebdb1968e5f3b2e3eada47b625cde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/pliage_metal_acl_2.jpg
// module id = jojB
// module chunks = 0